var React = require('react');

function IconPricingPlanPremium (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25 6.44409C25.516 6.44409 26.031 6.60309 26.469 6.92109L42.69 18.7071C43.128 19.0251 43.439 19.4671 43.598 19.9571C43.757 20.4471 43.765 20.9871 43.598 21.5021L37.402 40.5711C37.235 41.0861 36.911 41.5181 36.494 41.8211C36.077 42.1241 35.566 42.2981 35.025 42.2981H14.975C14.433 42.2981 13.923 42.1241 13.506 41.8211C13.089 41.5181 12.765 41.0861 12.598 40.5711L6.40102 21.5021C6.23402 20.9871 6.24202 20.4471 6.40102 19.9571C6.56002 19.4671 6.87102 19.0251 7.30902 18.7071L23.531 6.92209C23.969 6.60409 24.485 6.44509 25 6.44509V6.44409Z","stroke":"#53CAEE","strokeWidth":"3"}));
}

IconPricingPlanPremium.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = IconPricingPlanPremium;

IconPricingPlanPremium.default = IconPricingPlanPremium;
